// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H8Iv","rootNoMargin":"styles_rootNoMargin__2hYxe"};